/**
 * Param-schema cho form kiem thu. Nguon chan ly da chuyen vao @gw/shared (dung
 * chung voi Gateway: catalog cong khai + seed backfill). File nay chi:
 *  - re-export type/helper tu @gw/shared (giu nguyen import cu o cac component)
 *  - them resolveModelParams(): UU TIEN paramsSchema trong DB, fallback theo code.
 */
import { getModelParams, type ParamField } from '@gw/shared';

export type { ParamType, ParamField, ModelParamsInput } from '@gw/shared';
export { getModelParams, UPLOAD_TYPES } from '@gw/shared';

/** Shape toi thieu de resolve param (ProviderModel thoa man cau truc nay). */
interface ResolveInput {
  code: string;
  submitEndpoint?: string | null;
  config?: unknown;
  paramsSchema?: ParamField[] | null;
}

/**
 * Tra ve param cho 1 model: uu tien `paramsSchema` (sua trong admin / DB),
 * fallback `getModelParams` (BY_CODE / endpoint) cho model cu chua co schema.
 */
export function resolveModelParams(model: ResolveInput): ParamField[] {
  if (Array.isArray(model.paramsSchema) && model.paramsSchema.length) {
    return model.paramsSchema as ParamField[];
  }
  return getModelParams({ code: model.code, submitEndpoint: model.submitEndpoint });
}
